<template>
  <div
    class="flow-header"
    :class="{
      'flow-header--extra-spacing': extraSpacing,
      'flow-header--no-progress': hideProgress,
    }"
  >
    <div v-if="!hideProgress" class="progress-bar-container">
      <div class="progress-bar" :style="{ width: progressWidth }"></div>
    </div>
    <div class="header-row">
      <button
        v-if="showBack"
        class="back-button"
        @click="$emit('back')"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#205441" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M5 12h14M12 5l7 7-7 7"/>
        </svg>
      </button>
      <div class="logo-container">
        <img :src="logoUrl" alt="RiseUp" class="logo" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FlowHeader',
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
    totalSteps: {
      type: Number,
      default: 5,
    },
    showBack: {
      type: Boolean,
      default: false,
    },
    extraSpacing: {
      type: Boolean,
      default: false,
    },
    hideProgress: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    progressWidth() {
      return `${(this.currentStep / this.totalSteps) * 100}%`;
    },
    logoUrl() {
      // eslint-disable-next-line global-require
      return require('@/pages/responsive-pages/non-authenticated/mortgage-refinance/assets/riseup-logo-green.svg');
    },
  },
};
</script>

<style lang="scss" scoped>
.flow-header {
  width: 100%;
  padding-top: 20px;
  padding-bottom: 48px;
  position: relative;

  @media (max-width: 500px) {
    padding-top: 8px;
  }

  // No progress bar = no visual weight at the very top, so the logo sits
  // too close to the frame edge. Push it down by ~32px so it has the same
  // breathing room a progress bar would have provided.
  &--no-progress {
    padding-top: 52px;

    @media (max-width: 500px) {
      padding-top: 40px;
    }
  }

  // Extra 40px below the logo only on desktop / long mobile viewports
  // (short viewports keep the original spacing so content still fits).
  &--extra-spacing {
    @media (min-height: 751px) {
      padding-bottom: 88px;
    }
  }
}

.progress-bar-container {
  height: 3px;
  background: rgba(32, 84, 65, 0.1);
  border-radius: 2px;
  // Match the horizontal inset of the page's content (cards / question
  // items) — they sit 24px in from each side of the flow-content frame.
  margin: 0 24px 20px;
}

.progress-bar {
  height: 100%;
  background: #00C070;
  border-radius: 2px;
  transition: width 0.3s ease-out;
}

.header-row {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
}

.back-button {
  position: absolute;
  // Align the arrow icon's right edge with the right edge of the
  // progress bar above it. The progress bar (.progress-bar-container,
  // 307px wide) sits centered in the header-row. The button has 4px
  // internal padding, so we offset by (bar-margin + 4px) on the right:
  //   (header-row-width - 307) / 2 + 4  ≈ 37.5px + 4px ≈ calc(50% - 149.5px).
  // Using a hardcoded px value rather than calc keeps it simple.
  right: 33px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;

  &:active {
    opacity: 0.6;
  }
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo {
  width: 73px;
  height: 21px;
}
</style>
